import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import CloseIconSvg from 'public/icons/close.svg';

import { Button } from '../_Button/Button';

import styles from './_MicroModal.module.css';

type MicroModalProps = {
	children: ReactNode;
	modalState: boolean;
	closeModal: () => void;
	showAbove?: boolean;
	className?: string;
};

export default function MicroModal(props: MicroModalProps): JSX.Element {
	const wrapper = useRef<HTMLDivElement>(null);
	const [style, setStyle] = useState<CSSProperties>({});

	function focusModal() {
		wrapper.current?.focus();
	}

	function fixOverflow() {
		if (!wrapper.current) {
			return;
		}

		const leftMargin = wrapper.current.getBoundingClientRect().left - 16;

		if (leftMargin < 0) {
			setStyle({ transform: `translateX(${leftMargin * -1}px)` });
		}
	}

	useEffect(() => {
		if (props.modalState) {
			focusModal();
		}
	}, [props.children, props.modalState]);

	return (
		<CSSTransition
			nodeRef={wrapper}
			in={props.modalState}
			timeout={200}
			classNames={{ ...styles }}
			onEnter={() => fixOverflow()}
			onEntered={() => focusModal()}
			onExited={() => setStyle({})}
			unmountOnExit
		>
			<div
				ref={wrapper}
				tabIndex={0}
				onBlur={(e: React.FocusEvent) => {
					if (!e.currentTarget.contains(e.relatedTarget)) {
						props.closeModal();
					}
				}}
				className={`${styles.wrapper} ${props.showAbove ? 'above' : ''}`}
				style={style}
			>
				<div className={`${styles.modal} ${props.className}`}>
					<Button title="Close" className={styles.close} onClick={() => props.closeModal()}>
						<CloseIconSvg />
					</Button>

					<div>{props.children}</div>
				</div>
			</div>
		</CSSTransition>
	);
}
